import React, { useEffect, useState, useContext, useRef } from 'react';
import './Components.css';
import { AppContext, ViewOnlyContext } from '../contexts/AppContext';
import { Cross2Icon } from '../icons/Icons';
import { useAppStateService } from '../contexts/AppState';
import { IsPlateCorSetup } from '../isdlData/sessionData';

function SetupListContextMenu({ ContextLocation, CurrentSession, CurrentSetup, HandleSetupContext }) {
    const appState = useAppStateService();
    const menuRef = useRef(null);
    const [position, setPosition] = useState({ top: ContextLocation.y, left: ContextLocation.x });
    const { viewOnly } = useContext(ViewOnlyContext);

    useEffect(() => {
        const adjustPosition = () => {
            if (menuRef.current) {
                const { offsetWidth, offsetHeight } = menuRef.current;
                const screenWidth = window.innerWidth;
                const screenHeight = window.innerHeight;
        
                // Get the --desktop-right-panel-size CSS variable value
                const rightPanelSize = parseInt(
                    getComputedStyle(document.documentElement)
                        .getPropertyValue('--desktop-right-panel-size')
                        .trim(),
                    10
                ) || 0; // Fallback to 0 if parsing fails
        
                let newLeft = ContextLocation.x;
                let newTop = ContextLocation.y;
        
                // Ensure menu does not overflow on the right
                if (newLeft + offsetWidth > screenWidth) {
                    newLeft = screenWidth - offsetWidth - 10;
                }
        
                // Ensure menu does not overflow at the bottom
                if (newTop + offsetHeight > screenHeight) {
                    newTop = screenHeight - offsetHeight - 10;
                }
        
                // Ensure menu does not go out of the top/left bounds
                newLeft = Math.max(10, newLeft - rightPanelSize );
                newTop = Math.max(10, newTop);
        
                setPosition({ top: newTop, left: newLeft });
            }
        };
        

        adjustPosition();
    }, [ContextLocation]);

    const handleOptionClicked = (option) => {
        HandleSetupContext(option);
    };

    const IsTopMostSetup = () => {
        const idx = CurrentSession.SessionSetups.findIndex(s => s.Id === CurrentSetup.Id);
        return idx === 0;
    }

    const IsBottomMostSetup = () => {
        const idx = CurrentSession.SessionSetups.findIndex(s => s.Id === CurrentSetup.Id);
        return idx === CurrentSession.SessionSetups.length - 1;
    }

    const canImportPlateShots = IsPlateCorSetup(CurrentSetup);

    return (
        <div 
            ref={menuRef} 
            className='desktop-setuplist-context-menu'
            style={{ top: `${position.top}px`, left: `${position.left}px` }}>
            <button className='modal-close-button' onClick={() => handleOptionClicked("CLOSE")} style={{zIndex:'10'}}><Cross2Icon width='30px' height='30px'/></button>

            <span style={{ height: '40px', alignContent: 'center', fontWeight: 'bold', marginTop:'10px'}}>{CurrentSetup.ClubId}</span>

            {CurrentSetup.hasOwnProperty('BaseComponentSN') && (
                <div className='desktop-setuplist-data-item-container'>
                <span className='desktop-setuplist-data-item-header'>Base SN</span>
                <span className='desktop-setuplist-data-item-content'>{CurrentSetup['BaseComponentSN'] ? CurrentSetup['BaseComponentSN'] : 'N/A'}</span>
            </div>
            )}
            {CurrentSetup.hasOwnProperty('HeadSN') && (
                <div className='desktop-setuplist-data-item-container'>
                <span className='desktop-setuplist-data-item-header'>Head SN</span>
                <span className='desktop-setuplist-data-item-content'>{CurrentSetup['HeadSN'] ? CurrentSetup['HeadSN'] : 'N/A'}</span>
            </div>
            )}
            {CurrentSetup.hasOwnProperty('ShaftSN') && (
                <div className='desktop-setuplist-data-item-container'>
                <span className='desktop-setuplist-data-item-header'>Shaft SN</span>
                <span className='desktop-setuplist-data-item-content'>{CurrentSetup['ShaftSN'] ? CurrentSetup['ShaftSN'] : 'N/A'}</span>
            </div>
            )}
            {CurrentSetup.hasOwnProperty('MeasuredLoft') && (
                <div className='desktop-setuplist-data-item-container'>
                <span className='desktop-setuplist-data-item-header'>Loft</span>
                <span className='desktop-setuplist-data-item-content'>{CurrentSetup['MeasuredLoft'] ? CurrentSetup['MeasuredLoft'] : 'N/A'}</span>
            </div>
            )}
            {CurrentSetup.hasOwnProperty('MeasuredLie') && (
                <div className='desktop-setuplist-data-item-container'>
                <span className='desktop-setuplist-data-item-header'>Lie</span>
                <span className='desktop-setuplist-data-item-content'>{CurrentSetup['MeasuredLie'] ? CurrentSetup['MeasuredLie'] : 'N/A'}</span>
            </div>
            )}
            {CurrentSetup.hasOwnProperty('MeasuredMass') && (
                <div className='desktop-setuplist-data-item-container'>
                <span className='desktop-setuplist-data-item-header'>Mass</span>
                <span className='desktop-setuplist-data-item-content'>{CurrentSetup['MeasuredMass'] ? CurrentSetup['MeasuredMass'] : 'N/A'}</span>
            </div>
            )}
            {CurrentSetup.hasOwnProperty('MeasuredClubLength') && (
                <div className='desktop-setuplist-data-item-container'>
                <span className='desktop-setuplist-data-item-header'>Club Length</span>
                <span className='desktop-setuplist-data-item-content'>{CurrentSetup['MeasuredClubLength'] ? CurrentSetup['MeasuredClubLength'] : 'N/A'}</span>
            </div>
            )}
            {CurrentSetup.hasOwnProperty('MeasuredClubSwingWeight') && (
                <div className='desktop-setuplist-data-item-container'>
                <span className='desktop-setuplist-data-item-header'>Club SW</span>
                <span className='desktop-setuplist-data-item-content'>{CurrentSetup['MeasuredClubSwingWeight'] ? CurrentSetup['MeasuredClubSwingWeight'] : 'N/A'}</span>
            </div>
            )}
            {CurrentSetup.hasOwnProperty('MeasuredClubFrequency') && (
                <div className='desktop-setuplist-data-item-container'>
                <span className='desktop-setuplist-data-item-header'>Club Freq.</span>
                <span className='desktop-setuplist-data-item-content'>{CurrentSetup['MeasuredClubFrequency'] ? CurrentSetup['MeasuredClubFrequency'] : 'N/A'}</span>
            </div>
            )}
            {/* <span style={{ height: '40px', alignContent: 'center', fontWeight: 'bold' }}>Manufacturer: {CurrentSetup.ClubManufacturer}</span>
            <span style={{ height: '40px', alignContent: 'center', fontWeight: 'bold' }}>Club Name: {CurrentSetup.ClubName}</span>
            <span style={{ height: '40px', alignContent: 'center', fontWeight: 'bold' }}>Description: {CurrentSetup.ClubDescription ? CurrentSetup.ClubDescription : "N/A"}</span>
            <span style={{ height: '40px', alignContent: 'center', fontWeight: 'bold' }}>Club Type: {CurrentSetup.ClubCategory}</span> */}
            {(!viewOnly && (
                <>
                    <button className='button' style={{ marginTop: '10px', width: 'auto', minWidth: '200px' }} onClick={() => handleOptionClicked("RENAME")}>Edit</button>
                    <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-evenly' }}>
                        <button className='button' style={{ marginTop: '10px', width: '50%' }} disabled={IsTopMostSetup()} onClick={() => handleOptionClicked("MOVEUP")}>Move Up</button>
                        <button className='button' style={{ marginTop: '10px', width: '50%' }} disabled={IsBottomMostSetup()} onClick={() => handleOptionClicked("MOVEDOWN")}>Move Down</button>
                    </div>
                    <button className='button' style={{ marginTop: '10px', width: 'auto', minWidth: '200px' }} onClick={() => handleOptionClicked("CHANGELETTER")}>Update Letter Id</button>
                    <button className='button' style={{ marginTop: '10px', width: 'auto', minWidth: '200px' }} onClick={() => handleOptionClicked("CHANGEGROUPNUM")}>Edit Group Number(s)</button>
                    {canImportPlateShots && (
                        <button className='button' style={{ marginTop: '10px', width: 'auto', minWidth: '200px' }} onClick={() => handleOptionClicked("IMPORTPLATESHOTS")}>Import Plate Shots</button>
                    )}
                    <button className='button' style={{ marginTop: '10px', width: 'auto', minWidth: '200px' }} onClick={() => handleOptionClicked("CLONE")}>Clone</button>
                </>
            ))}
        </div>
    );
}

export default SetupListContextMenu;
